/* globals $ */
import { createFilmStripGallery } from './galleries/filmstrip.js';
/****** KMS Gallery plugin ******/
export function KMSGallery(element){
    element = element || document;

    [...element.querySelectorAll(".kmsgallery")].forEach(function(gallery){
        if (gallery.classList.contains('display-default')) {
            if (typeof $ === 'function'){ 
                let $gallery = $(gallery);
                $gallery.magnificPopup({
                    delegate:'.kmsgallery-thumbnail-image',
                    type: 'image',
                    gallery:{
                    enabled:true
                    }
                });
            }
        } else if (gallery.classList.contains('display-filmstrip')) {
            createFilmStripGallery(gallery);
        } else if (gallery.classList.contains('display-slider')) {
            if (typeof $ === 'function'){ 
                let $gallery = $(gallery);
                $gallery.flexslider({
                    prevText: "",
                    nextText: "",
                    smoothHeight: true,
                    slideshow: false,
                    directionNav: true,
                    controlNav: false,
                    animation:"slide"
                });
            } else {
                console.error("Flexslider requires jquery to be loaded.");
            }
        } else if (gallery.classList.contains('display-rotate')) {
            createRotateGallery(gallery);
        }
    });

}
window.createFilmStripGallery = createFilmStripGallery;
function createRotateGallery(gallery){
    if (typeof $ !== 'function'){
        console.error("Filmstrip gallery requires jquery to be loaded.");
        return;
    }
    let $gallery = $(gallery);
    var interval = null;
    var $images = $gallery.find('.kmsgallery-image');
    var $nav = $('<div class="kmsgallery-nav"></div>');
    $gallery.append($nav);
    $images.each(function(index,el){
        var navitem = $('<span class="kmsgallery-nav-item"></span>');
        var $el = $(el);
        $nav.append(navitem);
        navitem.data('image', $el);
        $el.data('nav', navitem);
        if ($el.hasClass('active'))
            navitem.addClass('active');
    });
    var $navitems = $nav.children();
    function activateNav(nav){
        $navitems.removeClass('active');
        $images.removeClass('active');
        nav.addClass('active').data('image').addClass('active');
    }
    function stepCarousel() {
        var $next = $navitems.filter('.active').next();
        if (!$next.length) {
            $next = $navitems.first();
        }
        activateNav($next);
    }
    function resetTimer(){
        stopCarousel();
        startCarousel();
    }
    function startCarousel(){
        interval = setInterval(stepCarousel, 7000);
    }
    function stopCarousel(){
        clearInterval(interval);
    }
    $nav.on('click','.kmsgallery-nav-item',function(){resetTimer();activateNav($(this));});
    startCarousel();
}
window.createRotateGallery = createRotateGallery;
